export default "__VITE_ASSET__BZJcJrOT__"